import {
  Box,
  Button,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  InputField,
  Modal,
  Toggle,
  Tree,
  Typography,
  useToast,
} from "fds";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { nanoid } from "@reduxjs/toolkit";
import {
  AllowIpListDto,
  AssignmentDto,
  TypeDto,
} from "../../types/adminSetting";
import utilsCommon from "../../shared/utils/common";
import useAdminSettingStore from "../../redux/dispatcher/useAdminSettingStore";
import useAdminDeptStore from "../../redux/dispatcher/useAdminDeptStore";

export type ModalProps = {
  showInsertOrUpdateAssignment: boolean;
  targetAssignment?: AssignmentDto;
  toggleInsertOrUpdateAssignment: (open: boolean) => void;
  typeList: TypeDto[];
};
const InsertOrUpdateAssignmentModal: React.FC<ModalProps> = ({
  showInsertOrUpdateAssignment,
  targetAssignment,
  toggleInsertOrUpdateAssignment,
  typeList,
}) => {
  const { getAssingment, createAssignment, updateAssignment } =
    useAdminSettingStore();
  const { adminDeptStore, getDeptDetail, getDeptUsers } = useAdminDeptStore();
  const toast = useToast();

  /**** State 모음 ****/
  const [simpleInfo, setSimpleInfo] = useState({
    adminId: "",
    atName: "",
    atCode: typeList.length > 0 ? typeList[0].atCode + "" : "",
    multiFactor: "MAIL_OTP",
    allowIpList: [] as AllowIpListDto[],
    updatedTime: 0,
  });
  const [ipList, setIPList] = useState([] as AllowIpListDto[]);
  const [ipRangeList, setIPRangetList] = useState([] as AllowIpListDto[]);
  const [isEditmode, setEditMode] = useState(false);
  const [targetUser, setTargetUser] = useState({ id: "", name: "" });
  const [showDeptUser, toggleDeptUser] = useState(false);
  const [buttonClick, setButtonClick] = useState<number>(0);
  const [expandValues, setExpandValues] = useState([
    "ae4fc0f5fd8f4142834c1ad4e929a514",
  ] as string[]);

  const { t } = useTranslation();

  /**** UseEffect 모음 ****/
  useEffect(() => {
    getDeptDetail("ae4fc0f5fd8f4142834c1ad4e929a514");
    getDeptUsers("ae4fc0f5fd8f4142834c1ad4e929a514");
    if (targetAssignment && targetAssignment.adminId) {
      setEditMode(true);
      setSimpleInfo({
        adminId: targetAssignment.adminId,
        atName: targetAssignment.userInfo
          ? targetAssignment.userInfo?.name
          : "",
        atCode: targetAssignment.atCode,
        multiFactor: targetAssignment.multiFactor,
        allowIpList: targetAssignment.allowIpList,
        updatedTime: targetAssignment.updatedTime,
      });
      targetAssignment.allowIpList.map((item) => {
        if (item.ipFromStr === item.ipToStr) {
          ipList.push({
            ipFromStr: item.ipFromStr,
            ipToStr: item.ipToStr,
            uid: uuidv4(),
            aclCode: item.aclCode,
            adminId: item.adminId,
            ipFrom: item.ipFrom,
            ipTo: item.ipTo,
          });
        } else {
          ipRangeList.push({
            ipFromStr: item.ipFromStr,
            ipToStr: item.ipToStr,
            uid: uuidv4(),
            aclCode: item.aclCode,
            adminId: item.adminId,
            ipFrom: item.ipFrom,
            ipTo: item.ipTo,
          });
        }
      });
    }
  }, []);

  const searchTree = (value: string): void => {
    getDeptDetail(value);
    getDeptUsers(value);
  };
  const checkIpValid = () => {
    return !(
      ipList.filter((item) => !utilsCommon.checkIpRegex(item.ipFromStr))
        .length > 0 ||
      ipRangeList.filter(
        (item) =>
          !utilsCommon.checkIpRegex(item.ipFromStr) ||
          !utilsCommon.checkIpRegex(item.ipToStr)
      ).length > 0
    );
  };
  const changeSimpleAllowIps = (): AllowIpListDto[] => {
    if (!checkIpValid()) {
      return [];
    }
    let tempAllowIPList = [] as AllowIpListDto[];
    ipList.map((item) =>
      tempAllowIPList.push({
        ipFromStr: item.ipFromStr,
        ipToStr: item.ipFromStr,
        aclCode: item.aclCode ? item.aclCode : undefined,
        adminId: item.aclCode ? item.adminId : undefined,
        ipFrom: item.aclCode ? item.ipFrom : undefined,
        ipTo: item.aclCode ? item.ipTo : undefined,
      })
    );
    ipRangeList.map((item) =>
      tempAllowIPList.push({
        ipFromStr: item.ipFromStr,
        ipToStr: item.ipToStr,
        aclCode: item.aclCode ? item.aclCode : undefined,
        adminId: item.aclCode ? item.adminId : undefined,
        ipFrom: item.aclCode ? item.ipFrom : undefined,
        ipTo: item.aclCode ? item.ipTo : undefined,
      })
    );
    return tempAllowIPList;
  };
  const updateAssignmentFunc = async () => {
    let result: any;
    if (!isEditmode) {
      let tempIpList = changeSimpleAllowIps();
      if (
        tempIpList.length > 0 ||
        (ipList.length === 0 && ipRangeList.length === 0)
      ) {
        result = await createAssignment({
          adminId: simpleInfo.adminId,
          allowIpList: tempIpList,
          atCode: simpleInfo.atCode,
          multiFactor: simpleInfo.multiFactor,
        });
        getAssingment();
        toggleInsertOrUpdateAssignment(false);
      } else {
        toast.toastMsg(
          nanoid(),
          t("admin.adminSetting.invalidIpAddress"),
          "error"
        );
      }
    } else {
      let tempIpList = changeSimpleAllowIps();
      if (
        tempIpList.length > 0 ||
        (ipList.length === 0 && ipRangeList.length === 0)
      ) {
        result = await updateAssignment({
          adminId: simpleInfo.adminId,
          allowIpList: tempIpList,
          atCode: simpleInfo.atCode,
          multiFactor: simpleInfo.multiFactor,
          updatedTime: simpleInfo.updatedTime,
        });
        toggleInsertOrUpdateAssignment(false);
      } else {
        toast.toastMsg(
          nanoid(),
          t("admin.adminSetting.invalidIpAddress"),
          "error"
        );
      }
    }
    if (result.error) {
      switch (result.error.name) {
        case "EXIST_ADMIN_ASSIGNMENT":
          toast.toastMsg(
            nanoid(),
            t("admin.adminSetting.existAdminAssignment"),
            "error"
          );
          break;
        default:
          toast.toastMsg(nanoid(), result.error.message, "error");
      }
    }
  };
  return (
    <Modal
      open={showInsertOrUpdateAssignment}
      onClose={() => toggleInsertOrUpdateAssignment(false)}
      title={t("admin.adminSetting.assignmenTitle")}
      subTitle={t("admin.adminSetting.assignmenDesc")}
      footer={
        <Box justifyContent="flex-end" classes="separateBox">
          <Button
            label={t("admin.common.button.cancel")}
            btnStyle="fill"
            type="secondary"
            onClick={() => toggleInsertOrUpdateAssignment(false)}
          />
          <Button
            label={t("admin.common.button.ok")}
            btnStyle="fill"
            type="primary"
            onClick={() => {
              updateAssignmentFunc();
            }}
            classes={"mg ml-10"}
            state={
              simpleInfo.adminId === "" ||
              ipList.filter((item) => item.ipFromStr === "").length > 0 ||
              ipRangeList.filter(
                (item) => item.ipFromStr === "" || item.ipToStr === ""
              ).length > 0
                ? "disable"
                : "default"
            }
          />
        </Box>
      }
      body={
        <Box direction="column" width={"100%"}>
          <Typography type="subtitle2">
            {t("admin.adminSetting.basicInfo")}
          </Typography>
          <Box classes="typeModal-box first" justifyContent="space-between">
            <Box width={"30%"}>
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.adminSetting.userNameId")}
              </Typography>
            </Box>
            <Box width={"70%"} classes="typeModal-right" alignItems="center">
              <InputField
                size={"md"}
                value={
                  simpleInfo.atName
                    ? utilsCommon.getNameWithId(
                        simpleInfo.atName,
                        simpleInfo.adminId
                      )
                    : ""
                }
                placeholder=" "
                width={"100%"}
                disabled={true}
              />
              {!isEditmode && (
                <Button
                  classes="mg ml-8"
                  btnStyle={"fill"}
                  type="primary"
                  size={"md"}
                  onClick={() => {
                    if (simpleInfo.adminId !== "") {
                      setTargetUser({
                        id: simpleInfo.adminId,
                        name: simpleInfo.atName,
                      });
                    } else {
                      setTargetUser({
                        id: "",
                        name: "",
                      });
                    }
                    toggleDeptUser(true);
                  }}
                  width={80}
                  label={t("admin.common.button.search")}
                />
              )}
            </Box>
          </Box>
          <Box classes="typeModal-box" justifyContent="space-between">
            <Box width={"30%"}>
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.adminSetting.type")}
              </Typography>
            </Box>
            <Box width={"70%"}>
              <Dropdown
                classes="typeModal-select"
                width={428}
                btnSize="md"
                placeholder=" "
                buttonClick={buttonClick}
                value={
                  typeList.filter(
                    (item: any) => item.atCode === simpleInfo.atCode
                  ).length > 0
                    ? typeList.filter(
                        (item: any) => item.atCode === simpleInfo.atCode
                      )[0].atName
                    : " "
                }
              >
                {typeList.map((item: any) => (
                  <DropdownItem
                    onClick={() => {
                      setSimpleInfo({ ...simpleInfo, atCode: item.atCode });
                      setButtonClick(buttonClick + 1);
                    }}
                    label={item.atName}
                  ></DropdownItem>
                ))}
              </Dropdown>
            </Box>
          </Box>

          <Box classes="typeModal-box last" justifyContent="space-between">
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.adminSetting.otpLogin")}
            </Typography>
            <Toggle
              label={
                simpleInfo.multiFactor === "NONE"
                  ? t("admin.common.button.block")
                  : t("admin.common.button.allow")
              }
              checked={simpleInfo.multiFactor === "MAIL_OTP"}
              onChange={() => {
                setSimpleInfo({
                  ...simpleInfo,
                  multiFactor:
                    simpleInfo.multiFactor === "NONE" ? "MAIL_OTP" : "NONE",
                });
              }}
            />
          </Box>

          <Box height={"40px"} classes={"typeModal-box"}>
            <Typography type="subtitle2">
              {t("admin.adminSetting.ip")}
            </Typography>
            <Box>
              <Button
                label={t("admin.adminSetting.insertIp")}
                btnStyle="none"
                size="lg"
                textColor={getColor("COLOR_ICON_BRAND")}
                leadingIcon={
                  <Icons
                    variant="fill"
                    label="plusCircle"
                    stroke={
                      window.eco.companyName === "workspace"
                        ? "#6623e8"
                        : getColor("COLOR_ICON_BRAND")
                    }
                  />
                }
                onClick={() => {
                  let tempIPRange = [...ipList];
                  tempIPRange.push({
                    ipFromStr: "",
                    ipToStr: "",
                    uid: uuidv4(),
                  });
                  setIPList(tempIPRange);
                }}
              />
              <Button
                label={t("admin.adminSetting.insertIpRange")}
                btnStyle="none"
                size="lg"
                textColor={getColor("COLOR_ICON_BRAND")}
                leadingIcon={
                  <Icons
                    variant="fill"
                    label="plusCircle"
                    stroke={
                      window.eco.companyName === "workspace"
                        ? "#6623e8"
                        : getColor("COLOR_ICON_BRAND")
                    }
                  />
                }
                onClick={() => {
                  let tempIPRange = [...ipRangeList];
                  tempIPRange.push({
                    ipFromStr: "",
                    ipToStr: "",
                    uid: uuidv4(),
                  });
                  setIPRangetList(tempIPRange);
                }}
              />
            </Box>
          </Box>
          {ipList && ipList.length > 0 && (
            <Box classes="typeModal-ipBox">
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.adminSetting.insertIp")}
              </Typography>

              <Box width={"70%"} direction={"column"}>
                {ipList.length > 0 &&
                  ipList.map((item, index) => (
                    <Box alignItems="center">
                      <InputField
                        size="md"
                        classes="typeModal-typeIp mg mr-8"
                        onChange={(e) => {
                          if (!utilsCommon.ipNumber(e.target.value)) return;
                          let tempIPRange = [...ipList];
                          tempIPRange.filter(
                            (tempItem) => tempItem.uid === item.uid
                          )[0].ipFromStr = e.target.value;
                          setIPList(tempIPRange);
                        }}
                        value={
                          ipList.filter(
                            (tempItem) => tempItem.uid === item.uid
                          )[0].ipFromStr
                        }
                        maxLength={30}
                        placeholder={""}
                        width={380}
                      />
                      <Button
                        btnStyle="icon"
                        onClick={() => {
                          let tempIPRange = [...ipList];
                          tempIPRange = tempIPRange.filter(
                            (tempItem) => tempItem.uid !== item.uid
                          );
                          setIPList(tempIPRange);
                        }}
                        size="lg"
                        width={40}
                        textAlign="center"
                        leadingIcon={
                          <Icons variant="line" label="closeLarge" />
                        }
                      />
                    </Box>
                  ))}
              </Box>
            </Box>
          )}
          {ipRangeList && ipRangeList.length > 0 && (
            <Box classes="typeModal-ipBox">
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.adminSetting.insertIpRange")}
              </Typography>

              <Box width={"70%"} direction={"column"}>
                {ipRangeList.map((item, index) => (
                  <Box alignItems="center">
                    <InputField
                      size="md"
                      classes="typeModal-typeIp"
                      onChange={(e) => {
                        if (!utilsCommon.ipNumber(e.target.value)) return;
                        let tempIPRange = [...ipRangeList];
                        tempIPRange.filter(
                          (tempItem) => tempItem.uid === item.uid
                        )[0].ipFromStr = e.target.value;
                        setIPRangetList(tempIPRange);
                      }}
                      value={
                        ipRangeList.filter(
                          (tempItem) => tempItem.uid === item.uid
                        )[0].ipFromStr
                      }
                      placeholder=""
                      maxLength={30}
                      width={170}
                    />
                    <Box width={40} justifyContent="center">
                      ~
                    </Box>
                    <InputField
                      size="md"
                      classes="typeModal-typeIp mg mr-8"
                      onChange={(e) => {
                        if (!utilsCommon.ipNumber(e.target.value)) return;
                        let tempIPRange = [...ipRangeList];
                        tempIPRange.filter(
                          (tempItem) => tempItem.uid === item.uid
                        )[0].ipToStr = e.target.value;
                        setIPRangetList(tempIPRange);
                      }}
                      value={
                        ipRangeList.filter(
                          (tempItem) => tempItem.uid === item.uid
                        )[0].ipToStr
                      }
                      placeholder=""
                      maxLength={30}
                      width={170}
                    />
                    <Button
                      btnStyle="icon"
                      onClick={() => {
                        var tempIPRange = [...ipRangeList];
                        tempIPRange = tempIPRange.filter(
                          (tempItem) => tempItem.uid !== item.uid
                        );
                        setIPRangetList(tempIPRange);
                      }}
                      size="lg"
                      width={40}
                      textAlign="center"
                      leadingIcon={<Icons variant="line" label="closeLarge" />}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          )}
          {showDeptUser && (
            <Modal
              title={t("admin.adminSetting.selectUser")}
              footer={
                <Box justifyContent="flex-end">
                  <Button
                    label={t("admin.common.button.cancel")}
                    btnStyle="fill"
                    type="secondary"
                    onClick={() => (
                      setTargetUser({ id: "", name: "" }), toggleDeptUser(false)
                    )}
                  />
                  <Button
                    label={t("admin.common.button.ok")}
                    btnStyle="fill"
                    type="primary"
                    state={targetUser.id === "" ? "disable" : "default"}
                    onClick={() => (
                      setSimpleInfo({
                        ...simpleInfo,
                        adminId: targetUser.id,
                        atName: targetUser.name,
                      }),
                      setTargetUser({ id: "", name: "" }),
                      toggleDeptUser(false)
                    )}
                    classes={"mg ml-10"}
                  />
                </Box>
              }
              height={600}
              open={showDeptUser}
              onClose={() => (
                setTargetUser({ id: "", name: "" }), toggleDeptUser(false)
              )}
              body={
                <Box width={614}>
                  <Tree
                    width="100%"
                    height={"426px"}
                    treeData={{
                      columnText: t("admin.dept.internalUser"),
                      subTree: [...adminDeptStore.internalTree.subTree],
                      showChildren: true,
                      hasChildren: true,
                      value: "ae4fc0f5fd8f4142834c1ad4e929a514",
                      type: "company",
                    }}
                    expandAction={(value: string) => {
                      if (expandValues.includes(value)) {
                        setExpandValues(
                          expandValues.filter((item) => item !== value)
                        );
                      } else {
                        setExpandValues([...expandValues, value]);
                        searchTree(value);
                      }
                    }}
                    depth={0}
                    isOnlyUser
                    checkType="radio"
                    treeType="eco"
                    checkValues={[targetUser.id]}
                    checkAction={(value: any) => {
                      setTargetUser({
                        id: value.value,
                        name: value.columnText,
                      });
                    }}
                    expandValues={expandValues}
                    expandSearchValues={[]}
                  />
                </Box>
              }
            />
          )}
        </Box>
      }
    />
  );
};

export default InsertOrUpdateAssignmentModal;
